declare global {
  interface DocumentEventMap {
    scrollStop: Event;
  }
}

interface SmoothScrollOptions {
  offset?: number;
  onComplete?: () => void;
}

function detectScrollEnd(callback: () => void): void {
  let scrollTimeout: number;

  const handleScroll = () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = window.setTimeout(() => {
      window.removeEventListener('scroll', handleScroll);
      const scrollStopEvent = new Event('scrollStop');
      document.dispatchEvent(scrollStopEvent);
      callback();
    }, 100);
  };

  window.addEventListener('scroll', handleScroll);
  scrollTimeout = window.setTimeout(() => {
    window.removeEventListener('scroll', handleScroll);
    callback();
  }, 100);
}

export default function scrollToElement(
  element: Element | null,
  options: SmoothScrollOptions = {}
) {
  if (!element) {
    return;
  }

  const offset = options.offset === undefined ? 0 : options.offset;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - offset;

  if (options.onComplete) {
    detectScrollEnd(options.onComplete);
  }

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
}
